import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { isLoginFirst } from '@/utils/device';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue'), meta: { public: true } },
    { path: '/', name: 'dashboard', component: () => import('@/views/DashboardView.vue') },
    { path: '/venues', name: 'venues', component: () => import('@/views/VenuesView.vue') },
    { path: '/screens', name: 'screens', component: () => import('@/views/ScreensView.vue') },
    { path: '/playlists', name: 'playlists', component: () => import('@/views/PlaylistsView.vue') },
    { path: '/playlists/:id', name: 'playlist-editor', component: () => import('@/views/PlaylistEditorView.vue') },
    { path: '/library', name: 'library', component: () => import('@/views/LibraryView.vue') },
    { path: '/apk', name: 'apk', component: () => import('@/views/ApkView.vue') },
    { path: '/activate', name: 'activate', component: () => import('@/views/ActivateRedirect.vue') },
  ],
});

router.beforeEach(async (to) => {
  if (to.path === '/activate' && typeof to.query.code === 'string') {
    localStorage.setItem('pending_activation_code', to.query.code.trim());
  }
  const auth = useAuthStore();
  if (auth.token && !auth.user) await auth.hydrate();
  if (!to.meta.public && !auth.isAuthenticated) {
    // matchMedia может отсутствовать на старых ТВ-webview → fallback false (для ТВ это и нужно)
    const finePointer = window.matchMedia?.('(pointer:fine)')?.matches ?? false;
    if (isLoginFirst(navigator.userAgent, finePointer)) return { name: 'login' };
    window.location.href = '/api/download';   // ТВ/приставка → страница скачивания (вне SPA)
    return false;
  }
  if (to.name === 'login' && auth.isAuthenticated) return { name: 'dashboard' };
  return true;
});

export default router;
